import callAPiBase from './base';

const plantasApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/seatmapList',
      method: 'GET',
      useToken: true,
      title: 'Seatmap - List',
      params,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/seatmapGet',
      method: 'GET',
      useToken: true,
      title: 'Seatmap - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/seatmapCreate',
      method: 'POST',
      useToken: true,
      title: 'Seatmap - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/seatmapUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Seatmap - Update',
      data,
    }),
  delete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/seatmapDelete',
      method: 'PUT',
      useToken: true,
      title: 'Seatmap - Delete',
      data,
    }),
};

export { plantasApi };
export default plantasApi;
